module.exports = __webpack_public_path__ + "media/1.a08c2d63.mp3";